import axios from "axios";
import { getTrackingPayload, getSessionId } from "./utm";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 20000,
});

export async function submitQuoteLead(data) {
  const tracking = getTrackingPayload();
  const res = await http.post("/leads/quote", { ...data, ...tracking, session_id: getSessionId() });
  return res.data;
}

export async function submitCatalogLead(data) {
  const tracking = getTrackingPayload();
  const res = await http.post("/leads/catalog", { ...data, ...tracking });
  return res.data;
}

export async function submitSubscriptionLead(data) {
  const tracking = getTrackingPayload();
  const res = await http.post("/leads/subscribe", { ...data, ...tracking });
  return res.data;
}

export async function trackEvent(event_type, metadata = {}) {
  // Mirror to GTM dataLayer for WhatsApp clicks (single helper for all CTAs).
  if (event_type === "cta_whatsapp_click" && typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "whatsapp_click",
      source_section: metadata?.location || "unknown",
    });
  }
  try {
    const tracking = getTrackingPayload();
    await http.post("/events/track", {
      event_type,
      path: typeof window !== "undefined" ? window.location.pathname : null,
      session_id: getSessionId(),
      metadata,
      utm_source: tracking.utm_source,
      utm_medium: tracking.utm_medium,
      utm_campaign: tracking.utm_campaign,
      utm_term: tracking.utm_term,
      utm_content: tracking.utm_content,
    });
  } catch (_) {
    // no bloquea UX
  }
}

export const CATALOG_DOWNLOAD_URL = `${API}/leads/catalog/download`;

// Push a typed event to GTM dataLayer (safe on SSR).
export function gtmPush(eventName, payload = {}) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, ...payload });
}
